/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * macweb API
 * OpenAPI spec version: 0.4.45
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminContractsListParams,
  AdminDirectoryUsersListParams,
  AdminGroupsListParams,
  AdminMailLogsListParams,
  AdminSetUserPassword200,
  AdminSetUserPasswordBody,
  Contract,
  ContractCreateRequest,
  ContractCreateResponse,
  ContractUpdateRequest,
  DirectoryGroup,
  DirectoryIntegration,
  DirectoryUser,
  ErrorResponse,
  ImportOracleGroupsResponse,
  ImportOracleUsersResponse,
  IntegrationTestRequest,
  IntegrationTestResponse,
  MailLogEntry,
  MessageTemplate
} from '.././model';

import { customInstance } from '../../orvalMutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Test integration connection (mail or telegram)
 */
export const integrationTest = (
    slug: string,
    integrationTestRequest?: IntegrationTestRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<IntegrationTestResponse>(
      {url: `/api/admin/integrations/${slug}/test`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: integrationTestRequest, signal
    },
      options);
    }
  


export const getIntegrationTestMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof integrationTest>>, TError,{slug: string;data: IntegrationTestRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof integrationTest>>, TError,{slug: string;data: IntegrationTestRequest}, TContext> => {

const mutationKey = ['integrationTest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof integrationTest>>, {slug: string;data: IntegrationTestRequest}> = (props) => {
          const {slug,data} = props ?? {};

          return  integrationTest(slug,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type IntegrationTestMutationResult = NonNullable<Awaited<ReturnType<typeof integrationTest>>>
    export type IntegrationTestMutationBody = IntegrationTestRequest
    export type IntegrationTestMutationError = ErrorResponse

    /**
 * @summary Test integration connection (mail or telegram)
 */
export const useIntegrationTest = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof integrationTest>>, TError,{slug: string;data: IntegrationTestRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof integrationTest>>,
        TError,
        {slug: string;data: IntegrationTestRequest},
        TContext
      > => {

      const mutationOptions = getIntegrationTestMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary List contracts
 */
export const adminContractsList = (
    params?: AdminContractsListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Contract[]>(
      {url: `/api/admin/contracts`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getAdminContractsListQueryKey = (params?: AdminContractsListParams,) => {
    return [
    `/api/admin/contracts`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAdminContractsListQueryOptions = <TData = Awaited<ReturnType<typeof adminContractsList>>, TError = ErrorResponse>(params?: AdminContractsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminContractsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminContractsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminContractsList>>> = ({ signal }) => adminContractsList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminContractsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminContractsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminContractsList>>>
export type AdminContractsListQueryError = ErrorResponse


export function useAdminContractsList<TData = Awaited<ReturnType<typeof adminContractsList>>, TError = ErrorResponse>(
 params: undefined |  AdminContractsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminContractsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminContractsList>>,
          TError,
          Awaited<ReturnType<typeof adminContractsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminContractsList<TData = Awaited<ReturnType<typeof adminContractsList>>, TError = ErrorResponse>(
 params?: AdminContractsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminContractsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminContractsList>>,
          TError,
          Awaited<ReturnType<typeof adminContractsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminContractsList<TData = Awaited<ReturnType<typeof adminContractsList>>, TError = ErrorResponse>(
 params?: AdminContractsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminContractsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List contracts
 */

export function useAdminContractsList<TData = Awaited<ReturnType<typeof adminContractsList>>, TError = ErrorResponse>(
 params?: AdminContractsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminContractsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminContractsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create contract
 */
export const adminContractCreate = (
    contractCreateRequest: ContractCreateRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ContractCreateResponse>(
      {url: `/api/admin/contracts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: contractCreateRequest, signal
    },
      options);
    }
  


export const getAdminContractCreateMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminContractCreate>>, TError,{data: ContractCreateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adminContractCreate>>, TError,{data: ContractCreateRequest}, TContext> => {

const mutationKey = ['adminContractCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminContractCreate>>, {data: ContractCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  adminContractCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminContractCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminContractCreate>>>
    export type AdminContractCreateMutationBody = ContractCreateRequest
    export type AdminContractCreateMutationError = ErrorResponse

    /**
 * @summary Create contract
 */
export const useAdminContractCreate = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminContractCreate>>, TError,{data: ContractCreateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminContractCreate>>,
        TError,
        {data: ContractCreateRequest},
        TContext
      > => {

      const mutationOptions = getAdminContractCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get contract by ID
 */
export const adminContractGet = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Contract>(
      {url: `/api/admin/contracts/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getAdminContractGetQueryKey = (id?: string,) => {
    return [
    `/api/admin/contracts/${id}`
    ] as const;
    }

    
export const getAdminContractGetQueryOptions = <TData = Awaited<ReturnType<typeof adminContractGet>>, TError = ErrorResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminContractGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminContractGetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminContractGet>>> = ({ signal }) => adminContractGet(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminContractGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminContractGetQueryResult = NonNullable<Awaited<ReturnType<typeof adminContractGet>>>
export type AdminContractGetQueryError = ErrorResponse


export function useAdminContractGet<TData = Awaited<ReturnType<typeof adminContractGet>>, TError = ErrorResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminContractGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminContractGet>>,
          TError,
          Awaited<ReturnType<typeof adminContractGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminContractGet<TData = Awaited<ReturnType<typeof adminContractGet>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminContractGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminContractGet>>,
          TError,
          Awaited<ReturnType<typeof adminContractGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminContractGet<TData = Awaited<ReturnType<typeof adminContractGet>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminContractGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get contract by ID
 */

export function useAdminContractGet<TData = Awaited<ReturnType<typeof adminContractGet>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminContractGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminContractGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update contract
 */
export const adminContractUpdate = (
    id: string,
    contractUpdateRequest: ContractUpdateRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/admin/contracts/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: contractUpdateRequest
    },
      options);
    }
  


export const getAdminContractUpdateMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminContractUpdate>>, TError,{id: string;data: ContractUpdateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adminContractUpdate>>, TError,{id: string;data: ContractUpdateRequest}, TContext> => {

const mutationKey = ['adminContractUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminContractUpdate>>, {id: string;data: ContractUpdateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  adminContractUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminContractUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminContractUpdate>>>
    export type AdminContractUpdateMutationBody = ContractUpdateRequest
    export type AdminContractUpdateMutationError = ErrorResponse

    /**
 * @summary Update contract
 */
export const useAdminContractUpdate = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminContractUpdate>>, TError,{id: string;data: ContractUpdateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminContractUpdate>>,
        TError,
        {id: string;data: ContractUpdateRequest},
        TContext
      > => {

      const mutationOptions = getAdminContractUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Delete contract
 */
export const adminContractDelete = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/admin/contracts/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getAdminContractDeleteMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminContractDelete>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adminContractDelete>>, TError,{id: string}, TContext> => {

const mutationKey = ['adminContractDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminContractDelete>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  adminContractDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminContractDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof adminContractDelete>>>
    
    export type AdminContractDeleteMutationError = ErrorResponse

    /**
 * @summary Delete contract
 */
export const useAdminContractDelete = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminContractDelete>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminContractDelete>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAdminContractDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Установить пароль пользователя
 */
export const adminSetUserPassword = (
    id: string,
    adminSetUserPasswordBody: AdminSetUserPasswordBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AdminSetUserPassword200>(
      {url: `/api/admin/users/${id}/password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminSetUserPasswordBody, signal
    },
      options);
    }
  


export const getAdminSetUserPasswordMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSetUserPassword>>, TError,{id: string;data: AdminSetUserPasswordBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adminSetUserPassword>>, TError,{id: string;data: AdminSetUserPasswordBody}, TContext> => {

const mutationKey = ['adminSetUserPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminSetUserPassword>>, {id: string;data: AdminSetUserPasswordBody}> = (props) => {
          const {id,data} = props ?? {};

          return  adminSetUserPassword(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminSetUserPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof adminSetUserPassword>>>
    export type AdminSetUserPasswordMutationBody = AdminSetUserPasswordBody
    export type AdminSetUserPasswordMutationError = ErrorResponse

    /**
 * @summary Установить пароль пользователя
 */
export const useAdminSetUserPassword = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminSetUserPassword>>, TError,{id: string;data: AdminSetUserPasswordBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminSetUserPassword>>,
        TError,
        {id: string;data: AdminSetUserPasswordBody},
        TContext
      > => {

      const mutationOptions = getAdminSetUserPasswordMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Сбросить пароль пользователя
 */
export const adminDeleteUserPassword = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/admin/users/${id}/password`, method: 'DELETE'
    },
      options);
    }
  


export const getAdminDeleteUserPasswordMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDeleteUserPassword>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adminDeleteUserPassword>>, TError,{id: string}, TContext> => {

const mutationKey = ['adminDeleteUserPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminDeleteUserPassword>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  adminDeleteUserPassword(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminDeleteUserPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof adminDeleteUserPassword>>>
    
    export type AdminDeleteUserPasswordMutationError = ErrorResponse

    /**
 * @summary Сбросить пароль пользователя
 */
export const useAdminDeleteUserPassword = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDeleteUserPassword>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminDeleteUserPassword>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAdminDeleteUserPasswordMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary List directory users
 */
export const adminDirectoryUsersList = (
    params?: AdminDirectoryUsersListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DirectoryUser[]>(
      {url: `/api/admin/directory/users`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getAdminDirectoryUsersListQueryKey = (params?: AdminDirectoryUsersListParams,) => {
    return [
    `/api/admin/directory/users`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAdminDirectoryUsersListQueryOptions = <TData = Awaited<ReturnType<typeof adminDirectoryUsersList>>, TError = unknown>(params?: AdminDirectoryUsersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDirectoryUsersList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminDirectoryUsersListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminDirectoryUsersList>>> = ({ signal }) => adminDirectoryUsersList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminDirectoryUsersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminDirectoryUsersListQueryResult = NonNullable<Awaited<ReturnType<typeof adminDirectoryUsersList>>>
export type AdminDirectoryUsersListQueryError = unknown


export function useAdminDirectoryUsersList<TData = Awaited<ReturnType<typeof adminDirectoryUsersList>>, TError = unknown>(
 params: undefined |  AdminDirectoryUsersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDirectoryUsersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminDirectoryUsersList>>,
          TError,
          Awaited<ReturnType<typeof adminDirectoryUsersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminDirectoryUsersList<TData = Awaited<ReturnType<typeof adminDirectoryUsersList>>, TError = unknown>(
 params?: AdminDirectoryUsersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDirectoryUsersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminDirectoryUsersList>>,
          TError,
          Awaited<ReturnType<typeof adminDirectoryUsersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminDirectoryUsersList<TData = Awaited<ReturnType<typeof adminDirectoryUsersList>>, TError = unknown>(
 params?: AdminDirectoryUsersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDirectoryUsersList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List directory users
 */

export function useAdminDirectoryUsersList<TData = Awaited<ReturnType<typeof adminDirectoryUsersList>>, TError = unknown>(
 params?: AdminDirectoryUsersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDirectoryUsersList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminDirectoryUsersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create directory user
 */
export const adminDirectoryUsersCreate = (
    directoryUser: DirectoryUser,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/admin/directory/users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: directoryUser, signal
    },
      options);
    }
  


export const getAdminDirectoryUsersCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDirectoryUsersCreate>>, TError,{data: DirectoryUser}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adminDirectoryUsersCreate>>, TError,{data: DirectoryUser}, TContext> => {

const mutationKey = ['adminDirectoryUsersCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminDirectoryUsersCreate>>, {data: DirectoryUser}> = (props) => {
          const {data} = props ?? {};

          return  adminDirectoryUsersCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminDirectoryUsersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminDirectoryUsersCreate>>>
    export type AdminDirectoryUsersCreateMutationBody = DirectoryUser
    export type AdminDirectoryUsersCreateMutationError = unknown

    /**
 * @summary Create directory user
 */
export const useAdminDirectoryUsersCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDirectoryUsersCreate>>, TError,{data: DirectoryUser}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminDirectoryUsersCreate>>,
        TError,
        {data: DirectoryUser},
        TContext
      > => {

      const mutationOptions = getAdminDirectoryUsersCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get directory user
 */
export const adminDirectoryUsersGet = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DirectoryUser>(
      {url: `/api/admin/directory/users/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getAdminDirectoryUsersGetQueryKey = (id?: string,) => {
    return [
    `/api/admin/directory/users/${id}`
    ] as const;
    }

    
export const getAdminDirectoryUsersGetQueryOptions = <TData = Awaited<ReturnType<typeof adminDirectoryUsersGet>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDirectoryUsersGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminDirectoryUsersGetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminDirectoryUsersGet>>> = ({ signal }) => adminDirectoryUsersGet(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminDirectoryUsersGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminDirectoryUsersGetQueryResult = NonNullable<Awaited<ReturnType<typeof adminDirectoryUsersGet>>>
export type AdminDirectoryUsersGetQueryError = unknown


export function useAdminDirectoryUsersGet<TData = Awaited<ReturnType<typeof adminDirectoryUsersGet>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDirectoryUsersGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminDirectoryUsersGet>>,
          TError,
          Awaited<ReturnType<typeof adminDirectoryUsersGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminDirectoryUsersGet<TData = Awaited<ReturnType<typeof adminDirectoryUsersGet>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDirectoryUsersGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminDirectoryUsersGet>>,
          TError,
          Awaited<ReturnType<typeof adminDirectoryUsersGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminDirectoryUsersGet<TData = Awaited<ReturnType<typeof adminDirectoryUsersGet>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDirectoryUsersGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get directory user
 */

export function useAdminDirectoryUsersGet<TData = Awaited<ReturnType<typeof adminDirectoryUsersGet>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDirectoryUsersGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminDirectoryUsersGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update directory user
 */
export const adminDirectoryUsersUpdate = (
    id: string,
    directoryUser: DirectoryUser,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/admin/directory/users/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: directoryUser
    },
      options);
    }
  


export const getAdminDirectoryUsersUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDirectoryUsersUpdate>>, TError,{id: string;data: DirectoryUser}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adminDirectoryUsersUpdate>>, TError,{id: string;data: DirectoryUser}, TContext> => {

const mutationKey = ['adminDirectoryUsersUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminDirectoryUsersUpdate>>, {id: string;data: DirectoryUser}> = (props) => {
          const {id,data} = props ?? {};

          return  adminDirectoryUsersUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminDirectoryUsersUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminDirectoryUsersUpdate>>>
    export type AdminDirectoryUsersUpdateMutationBody = DirectoryUser
    export type AdminDirectoryUsersUpdateMutationError = unknown

    /**
 * @summary Update directory user
 */
export const useAdminDirectoryUsersUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDirectoryUsersUpdate>>, TError,{id: string;data: DirectoryUser}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminDirectoryUsersUpdate>>,
        TError,
        {id: string;data: DirectoryUser},
        TContext
      > => {

      const mutationOptions = getAdminDirectoryUsersUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Delete directory user
 */
export const adminDirectoryUsersDelete = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/admin/directory/users/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getAdminDirectoryUsersDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDirectoryUsersDelete>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adminDirectoryUsersDelete>>, TError,{id: string}, TContext> => {

const mutationKey = ['adminDirectoryUsersDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminDirectoryUsersDelete>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  adminDirectoryUsersDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminDirectoryUsersDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof adminDirectoryUsersDelete>>>
    
    export type AdminDirectoryUsersDeleteMutationError = unknown

    /**
 * @summary Delete directory user
 */
export const useAdminDirectoryUsersDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminDirectoryUsersDelete>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminDirectoryUsersDelete>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAdminDirectoryUsersDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Import users from Oracle
 */
export const adminUsersImportOracle = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ImportOracleUsersResponse>(
      {url: `/api/admin/users/import-oracle`, method: 'POST', signal
    },
      options);
    }
  


export const getAdminUsersImportOracleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUsersImportOracle>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adminUsersImportOracle>>, TError,void, TContext> => {

const mutationKey = ['adminUsersImportOracle'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminUsersImportOracle>>, void> = () => {
          

          return  adminUsersImportOracle(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminUsersImportOracleMutationResult = NonNullable<Awaited<ReturnType<typeof adminUsersImportOracle>>>
    
    export type AdminUsersImportOracleMutationError = unknown

    /**
 * @summary Import users from Oracle
 */
export const useAdminUsersImportOracle = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminUsersImportOracle>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminUsersImportOracle>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getAdminUsersImportOracleMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary List admin groups
 */
export const adminGroupsList = (
    params?: AdminGroupsListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DirectoryGroup[]>(
      {url: `/api/admin/groups`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getAdminGroupsListQueryKey = (params?: AdminGroupsListParams,) => {
    return [
    `/api/admin/groups`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAdminGroupsListQueryOptions = <TData = Awaited<ReturnType<typeof adminGroupsList>>, TError = unknown>(params?: AdminGroupsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGroupsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminGroupsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGroupsList>>> = ({ signal }) => adminGroupsList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGroupsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminGroupsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminGroupsList>>>
export type AdminGroupsListQueryError = unknown


export function useAdminGroupsList<TData = Awaited<ReturnType<typeof adminGroupsList>>, TError = unknown>(
 params: undefined |  AdminGroupsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGroupsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGroupsList>>,
          TError,
          Awaited<ReturnType<typeof adminGroupsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGroupsList<TData = Awaited<ReturnType<typeof adminGroupsList>>, TError = unknown>(
 params?: AdminGroupsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGroupsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGroupsList>>,
          TError,
          Awaited<ReturnType<typeof adminGroupsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGroupsList<TData = Awaited<ReturnType<typeof adminGroupsList>>, TError = unknown>(
 params?: AdminGroupsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGroupsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List admin groups
 */

export function useAdminGroupsList<TData = Awaited<ReturnType<typeof adminGroupsList>>, TError = unknown>(
 params?: AdminGroupsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGroupsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGroupsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create group
 */
export const adminGroupsCreate = (
    directoryGroup: DirectoryGroup,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/admin/groups`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: directoryGroup, signal
    },
      options);
    }
  


export const getAdminGroupsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminGroupsCreate>>, TError,{data: DirectoryGroup}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adminGroupsCreate>>, TError,{data: DirectoryGroup}, TContext> => {

const mutationKey = ['adminGroupsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminGroupsCreate>>, {data: DirectoryGroup}> = (props) => {
          const {data} = props ?? {};

          return  adminGroupsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminGroupsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminGroupsCreate>>>
    export type AdminGroupsCreateMutationBody = DirectoryGroup
    export type AdminGroupsCreateMutationError = unknown

    /**
 * @summary Create group
 */
export const useAdminGroupsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminGroupsCreate>>, TError,{data: DirectoryGroup}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminGroupsCreate>>,
        TError,
        {data: DirectoryGroup},
        TContext
      > => {

      const mutationOptions = getAdminGroupsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get group
 */
export const adminGroupsGet = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DirectoryGroup>(
      {url: `/api/admin/groups/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getAdminGroupsGetQueryKey = (id?: string,) => {
    return [
    `/api/admin/groups/${id}`
    ] as const;
    }

    
export const getAdminGroupsGetQueryOptions = <TData = Awaited<ReturnType<typeof adminGroupsGet>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGroupsGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminGroupsGetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGroupsGet>>> = ({ signal }) => adminGroupsGet(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGroupsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminGroupsGetQueryResult = NonNullable<Awaited<ReturnType<typeof adminGroupsGet>>>
export type AdminGroupsGetQueryError = unknown


export function useAdminGroupsGet<TData = Awaited<ReturnType<typeof adminGroupsGet>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGroupsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGroupsGet>>,
          TError,
          Awaited<ReturnType<typeof adminGroupsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGroupsGet<TData = Awaited<ReturnType<typeof adminGroupsGet>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGroupsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGroupsGet>>,
          TError,
          Awaited<ReturnType<typeof adminGroupsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGroupsGet<TData = Awaited<ReturnType<typeof adminGroupsGet>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGroupsGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get group
 */

export function useAdminGroupsGet<TData = Awaited<ReturnType<typeof adminGroupsGet>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGroupsGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGroupsGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update group
 */
export const adminGroupsUpdate = (
    id: string,
    directoryGroup: DirectoryGroup,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/admin/groups/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: directoryGroup
    },
      options);
    }
  


export const getAdminGroupsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminGroupsUpdate>>, TError,{id: string;data: DirectoryGroup}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adminGroupsUpdate>>, TError,{id: string;data: DirectoryGroup}, TContext> => {

const mutationKey = ['adminGroupsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminGroupsUpdate>>, {id: string;data: DirectoryGroup}> = (props) => {
          const {id,data} = props ?? {};

          return  adminGroupsUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminGroupsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminGroupsUpdate>>>
    export type AdminGroupsUpdateMutationBody = DirectoryGroup
    export type AdminGroupsUpdateMutationError = unknown

    /**
 * @summary Update group
 */
export const useAdminGroupsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminGroupsUpdate>>, TError,{id: string;data: DirectoryGroup}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminGroupsUpdate>>,
        TError,
        {id: string;data: DirectoryGroup},
        TContext
      > => {

      const mutationOptions = getAdminGroupsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Delete group
 */
export const adminGroupsDelete = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/admin/groups/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getAdminGroupsDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminGroupsDelete>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adminGroupsDelete>>, TError,{id: string}, TContext> => {

const mutationKey = ['adminGroupsDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminGroupsDelete>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  adminGroupsDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminGroupsDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof adminGroupsDelete>>>
    
    export type AdminGroupsDeleteMutationError = unknown

    /**
 * @summary Delete group
 */
export const useAdminGroupsDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminGroupsDelete>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminGroupsDelete>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAdminGroupsDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Import groups from Oracle
 */
export const adminGroupsImportOracle = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ImportOracleGroupsResponse>(
      {url: `/api/admin/groups/import-oracle`, method: 'POST', signal
    },
      options);
    }
  


export const getAdminGroupsImportOracleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminGroupsImportOracle>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adminGroupsImportOracle>>, TError,void, TContext> => {

const mutationKey = ['adminGroupsImportOracle'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminGroupsImportOracle>>, void> = () => {
          

          return  adminGroupsImportOracle(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminGroupsImportOracleMutationResult = NonNullable<Awaited<ReturnType<typeof adminGroupsImportOracle>>>
    
    export type AdminGroupsImportOracleMutationError = unknown

    /**
 * @summary Import groups from Oracle
 */
export const useAdminGroupsImportOracle = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminGroupsImportOracle>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminGroupsImportOracle>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getAdminGroupsImportOracleMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary List integrations
 */
export const adminIntegrationsList = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DirectoryIntegration[]>(
      {url: `/api/admin/integrations`, method: 'GET', signal
    },
      options);
    }
  



export const getAdminIntegrationsListQueryKey = () => {
    return [
    `/api/admin/integrations`
    ] as const;
    }

    
export const getAdminIntegrationsListQueryOptions = <TData = Awaited<ReturnType<typeof adminIntegrationsList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminIntegrationsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminIntegrationsListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminIntegrationsList>>> = ({ signal }) => adminIntegrationsList(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminIntegrationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminIntegrationsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminIntegrationsList>>>
export type AdminIntegrationsListQueryError = unknown


export function useAdminIntegrationsList<TData = Awaited<ReturnType<typeof adminIntegrationsList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminIntegrationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminIntegrationsList>>,
          TError,
          Awaited<ReturnType<typeof adminIntegrationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminIntegrationsList<TData = Awaited<ReturnType<typeof adminIntegrationsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminIntegrationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminIntegrationsList>>,
          TError,
          Awaited<ReturnType<typeof adminIntegrationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminIntegrationsList<TData = Awaited<ReturnType<typeof adminIntegrationsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminIntegrationsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List integrations
 */

export function useAdminIntegrationsList<TData = Awaited<ReturnType<typeof adminIntegrationsList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminIntegrationsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminIntegrationsListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get integration
 */
export const adminIntegrationsGet = (
    slug: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DirectoryIntegration>(
      {url: `/api/admin/integrations/${slug}`, method: 'GET', signal
    },
      options);
    }
  



export const getAdminIntegrationsGetQueryKey = (slug?: string,) => {
    return [
    `/api/admin/integrations/${slug}`
    ] as const;
    }

    
export const getAdminIntegrationsGetQueryOptions = <TData = Awaited<ReturnType<typeof adminIntegrationsGet>>, TError = unknown>(slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminIntegrationsGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminIntegrationsGetQueryKey(slug);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminIntegrationsGet>>> = ({ signal }) => adminIntegrationsGet(slug, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(slug), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminIntegrationsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminIntegrationsGetQueryResult = NonNullable<Awaited<ReturnType<typeof adminIntegrationsGet>>>
export type AdminIntegrationsGetQueryError = unknown


export function useAdminIntegrationsGet<TData = Awaited<ReturnType<typeof adminIntegrationsGet>>, TError = unknown>(
 slug: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminIntegrationsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminIntegrationsGet>>,
          TError,
          Awaited<ReturnType<typeof adminIntegrationsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminIntegrationsGet<TData = Awaited<ReturnType<typeof adminIntegrationsGet>>, TError = unknown>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminIntegrationsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminIntegrationsGet>>,
          TError,
          Awaited<ReturnType<typeof adminIntegrationsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminIntegrationsGet<TData = Awaited<ReturnType<typeof adminIntegrationsGet>>, TError = unknown>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminIntegrationsGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get integration
 */

export function useAdminIntegrationsGet<TData = Awaited<ReturnType<typeof adminIntegrationsGet>>, TError = unknown>(
 slug: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminIntegrationsGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminIntegrationsGetQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update integration
 */
export const adminIntegrationsUpdate = (
    slug: string,
    directoryIntegration: DirectoryIntegration,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/admin/integrations/${slug}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: directoryIntegration
    },
      options);
    }
  


export const getAdminIntegrationsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminIntegrationsUpdate>>, TError,{slug: string;data: DirectoryIntegration}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adminIntegrationsUpdate>>, TError,{slug: string;data: DirectoryIntegration}, TContext> => {

const mutationKey = ['adminIntegrationsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminIntegrationsUpdate>>, {slug: string;data: DirectoryIntegration}> = (props) => {
          const {slug,data} = props ?? {};

          return  adminIntegrationsUpdate(slug,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminIntegrationsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminIntegrationsUpdate>>>
    export type AdminIntegrationsUpdateMutationBody = DirectoryIntegration
    export type AdminIntegrationsUpdateMutationError = unknown

    /**
 * @summary Update integration
 */
export const useAdminIntegrationsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminIntegrationsUpdate>>, TError,{slug: string;data: DirectoryIntegration}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminIntegrationsUpdate>>,
        TError,
        {slug: string;data: DirectoryIntegration},
        TContext
      > => {

      const mutationOptions = getAdminIntegrationsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary List templates
 */
export const adminTemplatesList = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MessageTemplate[]>(
      {url: `/api/admin/templates`, method: 'GET', signal
    },
      options);
    }
  



export const getAdminTemplatesListQueryKey = () => {
    return [
    `/api/admin/templates`
    ] as const;
    }

    
export const getAdminTemplatesListQueryOptions = <TData = Awaited<ReturnType<typeof adminTemplatesList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTemplatesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminTemplatesListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminTemplatesList>>> = ({ signal }) => adminTemplatesList(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminTemplatesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminTemplatesListQueryResult = NonNullable<Awaited<ReturnType<typeof adminTemplatesList>>>
export type AdminTemplatesListQueryError = unknown


export function useAdminTemplatesList<TData = Awaited<ReturnType<typeof adminTemplatesList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTemplatesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminTemplatesList>>,
          TError,
          Awaited<ReturnType<typeof adminTemplatesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminTemplatesList<TData = Awaited<ReturnType<typeof adminTemplatesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTemplatesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminTemplatesList>>,
          TError,
          Awaited<ReturnType<typeof adminTemplatesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminTemplatesList<TData = Awaited<ReturnType<typeof adminTemplatesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTemplatesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List templates
 */

export function useAdminTemplatesList<TData = Awaited<ReturnType<typeof adminTemplatesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTemplatesList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminTemplatesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create template
 */
export const adminTemplatesCreate = (
    messageTemplate: MessageTemplate,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MessageTemplate>(
      {url: `/api/admin/templates`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: messageTemplate, signal
    },
      options);
    }
  


export const getAdminTemplatesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminTemplatesCreate>>, TError,{data: MessageTemplate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adminTemplatesCreate>>, TError,{data: MessageTemplate}, TContext> => {

const mutationKey = ['adminTemplatesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminTemplatesCreate>>, {data: MessageTemplate}> = (props) => {
          const {data} = props ?? {};

          return  adminTemplatesCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminTemplatesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adminTemplatesCreate>>>
    export type AdminTemplatesCreateMutationBody = MessageTemplate
    export type AdminTemplatesCreateMutationError = unknown

    /**
 * @summary Create template
 */
export const useAdminTemplatesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminTemplatesCreate>>, TError,{data: MessageTemplate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminTemplatesCreate>>,
        TError,
        {data: MessageTemplate},
        TContext
      > => {

      const mutationOptions = getAdminTemplatesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get template
 */
export const adminTemplatesGet = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MessageTemplate>(
      {url: `/api/admin/templates/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getAdminTemplatesGetQueryKey = (id?: string,) => {
    return [
    `/api/admin/templates/${id}`
    ] as const;
    }

    
export const getAdminTemplatesGetQueryOptions = <TData = Awaited<ReturnType<typeof adminTemplatesGet>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTemplatesGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminTemplatesGetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminTemplatesGet>>> = ({ signal }) => adminTemplatesGet(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminTemplatesGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminTemplatesGetQueryResult = NonNullable<Awaited<ReturnType<typeof adminTemplatesGet>>>
export type AdminTemplatesGetQueryError = unknown


export function useAdminTemplatesGet<TData = Awaited<ReturnType<typeof adminTemplatesGet>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTemplatesGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminTemplatesGet>>,
          TError,
          Awaited<ReturnType<typeof adminTemplatesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminTemplatesGet<TData = Awaited<ReturnType<typeof adminTemplatesGet>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTemplatesGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminTemplatesGet>>,
          TError,
          Awaited<ReturnType<typeof adminTemplatesGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminTemplatesGet<TData = Awaited<ReturnType<typeof adminTemplatesGet>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTemplatesGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get template
 */

export function useAdminTemplatesGet<TData = Awaited<ReturnType<typeof adminTemplatesGet>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminTemplatesGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminTemplatesGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update template
 */
export const adminTemplatesUpdate = (
    id: string,
    messageTemplate: MessageTemplate,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<MessageTemplate>(
      {url: `/api/admin/templates/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: messageTemplate
    },
      options);
    }
  


export const getAdminTemplatesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminTemplatesUpdate>>, TError,{id: string;data: MessageTemplate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adminTemplatesUpdate>>, TError,{id: string;data: MessageTemplate}, TContext> => {

const mutationKey = ['adminTemplatesUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminTemplatesUpdate>>, {id: string;data: MessageTemplate}> = (props) => {
          const {id,data} = props ?? {};

          return  adminTemplatesUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminTemplatesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof adminTemplatesUpdate>>>
    export type AdminTemplatesUpdateMutationBody = MessageTemplate
    export type AdminTemplatesUpdateMutationError = unknown

    /**
 * @summary Update template
 */
export const useAdminTemplatesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminTemplatesUpdate>>, TError,{id: string;data: MessageTemplate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminTemplatesUpdate>>,
        TError,
        {id: string;data: MessageTemplate},
        TContext
      > => {

      const mutationOptions = getAdminTemplatesUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Delete template
 */
export const adminTemplatesDelete = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/admin/templates/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getAdminTemplatesDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminTemplatesDelete>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adminTemplatesDelete>>, TError,{id: string}, TContext> => {

const mutationKey = ['adminTemplatesDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminTemplatesDelete>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  adminTemplatesDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminTemplatesDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof adminTemplatesDelete>>>
    
    export type AdminTemplatesDeleteMutationError = unknown

    /**
 * @summary Delete template
 */
export const useAdminTemplatesDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminTemplatesDelete>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminTemplatesDelete>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAdminTemplatesDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary List mail logs
 */
export const adminMailLogsList = (
    params?: AdminMailLogsListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MailLogEntry[]>(
      {url: `/api/admin/mail/logs`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getAdminMailLogsListQueryKey = (params?: AdminMailLogsListParams,) => {
    return [
    `/api/admin/mail/logs`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAdminMailLogsListQueryOptions = <TData = Awaited<ReturnType<typeof adminMailLogsList>>, TError = unknown>(params?: AdminMailLogsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMailLogsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminMailLogsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminMailLogsList>>> = ({ signal }) => adminMailLogsList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminMailLogsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminMailLogsListQueryResult = NonNullable<Awaited<ReturnType<typeof adminMailLogsList>>>
export type AdminMailLogsListQueryError = unknown


export function useAdminMailLogsList<TData = Awaited<ReturnType<typeof adminMailLogsList>>, TError = unknown>(
 params: undefined |  AdminMailLogsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMailLogsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMailLogsList>>,
          TError,
          Awaited<ReturnType<typeof adminMailLogsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMailLogsList<TData = Awaited<ReturnType<typeof adminMailLogsList>>, TError = unknown>(
 params?: AdminMailLogsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMailLogsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminMailLogsList>>,
          TError,
          Awaited<ReturnType<typeof adminMailLogsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminMailLogsList<TData = Awaited<ReturnType<typeof adminMailLogsList>>, TError = unknown>(
 params?: AdminMailLogsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMailLogsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List mail logs
 */

export function useAdminMailLogsList<TData = Awaited<ReturnType<typeof adminMailLogsList>>, TError = unknown>(
 params?: AdminMailLogsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminMailLogsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminMailLogsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




